import PropTypes from 'prop-types';

import { getPagePath, trans } from '@spotahome/soyuz/client';

import Button from '../../Button';

import './Hero.scss';

const Hero = ({ title, showCta = true }) => {
  return (
    <section className="hero-generic-error">
      <div className="hero-generic-error__content">
        <h1 className="hero-generic-error__title">{trans(title)}</h1>
        {showCta && (
          <Button href={getPagePath('landing')} color="secondary" size="large">
            {`< ${trans('error_page.not_found.cta')}`}
          </Button>
        )}
      </div>
      <img
        className="hero-generic-error__image"
        src="https://static.spotahome.com/images/no_results.svg"
        alt="Coverage Guarantee Icon"
      />
    </section>
  );
};

Hero.propTypes = {
  title: PropTypes.string.isRequired,
  showCta: PropTypes.bool
};

export default Hero;
